import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  useMediaQuery,
  Card,
  CardContent,
  Divider,
} from "@mui/material";
import { getFirestore, collection, query, where, getDocs } from "firebase/firestore";
import dayjs from "dayjs";
import Header from "../panel/Header";

const db = getFirestore();

function Allincomereport() {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [report, setReport] = useState([]);
  const [loading, setLoading] = useState(false);

  const isMobile = useMediaQuery("(max-width:768px)");

  const fetchReport = async () => {
    if (!fromDate || !toDate) {
      alert("Please select both dates");
      return;
    }
    setLoading(true);

    const start = new Date(fromDate);
    const end = new Date(toDate);
    end.setHours(23, 59, 59, 999);

    let data = [];

    try {
      // --- Sales Collection ---
      const q1 = query(
        collection(db, "sales"),
        where("created", ">=", start),
        where("created", "<=", end)
      );
      const snap1 = await getDocs(q1);
      snap1.forEach((doc) => {
        const d = doc.data();
        data.push({
          id: doc.id,
          date: d.created?.toDate() || d.SaleDate,
          section: d.category || "sales",
          amount: d.paidAmount || 0,
          type: d.paytype || "Cash",
          source: "Sales",
        });
      });

      // --- Takkevari Interests ---
      // const q2 = query(
      //   collection(db, "takkevariintrests"),
      //   where("createdAt", ">=", start),
      //   where("createdAt", "<=", end)
      // );
      // const snap2 = await getDocs(q2);
      // snap2.forEach((doc) => {
      //   const d = doc.data();
      //   data.push({
      //     id: doc.id,
      //     date: d.createdAt?.toDate(),
      //     section: "Takkevari",
      //     amount: d.interestAmount || 0,
      //     type: d.status || "",
      //     source: "Takkevari Interest",
      //   });
      // });

      // --- Loan EMIs ---
      // const q3 = query(
      //   collection(db, "loanemis"),
      //   where("date", ">=", start),
      //   where("date", "<=", end)
      // );
      // const snap3 = await getDocs(q3);
      // snap3.forEach((doc) => {
      //   const d = doc.data();
      //   data.push({
      //     id: doc.id,
      //     date: d.date?.toDate(),
      //     section: "Finance",
      //     amount: d.amountperday || 0,
      //     type: d.paymentType || "",
      //     source: "Loan EMI",
      //   });
      // });

      // Sort by date
      data.sort((a, b) => new Date(a.date) - new Date(b.date));

      setReport(data);
    } catch (err) {
      console.error("Error fetching report:", err);
    }
    setLoading(false);
  };

  return (
    <Box p={2}>
      <Header />

      {/* Date Filters with Total */}
      <Box display="flex" flexDirection={isMobile ? "column" : "row"} justifyContent="space-between" alignItems={isMobile ? "stretch" : "center"} gap={2} mb={2}>
        <Box display="flex" flexWrap="wrap" gap={2}>
          <TextField
            type="date"
            label="From Date"
            size="small"
            InputLabelProps={{ shrink: true }}
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
          />
          <TextField
            type="date"
            size="small"
            label="To Date"
            InputLabelProps={{ shrink: true }}
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
          />
          <Button variant="contained" onClick={fetchReport} disabled={loading}>
            {loading ? "Loading..." : "Fetch"}
          </Button>
        </Box>

        <Typography variant="h6" fontWeight="bold" color="primary" textAlign={isMobile ? "right" : "left"}>
          Total: ₹ {report.reduce((sum, r) => sum + (r.amount || 0), 0)}
        </Typography>
      </Box>

      {/* Desktop Table */}
      {!isMobile ? (
        <Paper elevation={3}>
          <TableContainer sx={{ maxHeight: 500 }}>
            <Table size="small" stickyHeader>
              <TableHead>
                <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                  <TableCell><b>Date</b></TableCell>
                  <TableCell><b>Source</b></TableCell>
                  <TableCell><b>Section</b></TableCell>
                  <TableCell align="right"><b>Amount</b></TableCell>
                  <TableCell><b>Type</b></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {report.map((row, index) => (
                  <TableRow
                    key={row.id}
                    sx={{
                      backgroundColor: index % 2 === 0 ? "#fafafa" : "white",
                      "&:hover": { backgroundColor: "#e3f2fd" },
                    }}
                  >
                    <TableCell>{dayjs(row.date).format("DD/MM/YYYY")}</TableCell>
                    <TableCell>{row.source}</TableCell>
                    <TableCell sx={{ textTransform: "capitalize" }}>{row.section}</TableCell>
                    <TableCell align="right">₹ {row.amount}</TableCell>
                    <TableCell>{row.type}</TableCell>
                  </TableRow>
                ))}
                {report.length === 0 && !loading && (
                  <TableRow>
                    <TableCell colSpan={5} align="center">
                      No data found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      ) : (
        // 📱 Mobile: Card layout
        <Box display="flex" flexDirection="column" gap={2}>
          {report.length > 0 ? (
            report.map((row) => (
              <Card key={row.id} variant="outlined" sx={{ borderRadius: 2, boxShadow: 2 }}>
                <CardContent>
                  <Typography variant="subtitle2" color="textSecondary">
                    {dayjs(row.date).format("DD/MM/YYYY")}
                  </Typography>
                  <Divider sx={{ my: 1 }} />
                  <Typography><b>Source:</b> {row.source}</Typography>
                  <Typography><b>Section:</b> {row.section}</Typography>
                  <Typography><b>Amount:</b> ₹ {row.amount}</Typography>
                  <Typography><b>Type:</b> {row.type}</Typography>
                </CardContent>
              </Card>
            ))
          ) : (
            !loading && <Typography align="center">No data found</Typography>
          )}
        </Box>
      )}
    </Box>
  );
}

export default Allincomereport;
